import { render, staticRenderFns } from "./StatusEdit.vue?vue&type=template&id=774359e2&scoped=true"
import script from "./StatusEdit.vue?vue&type=script&lang=js"
export * from "./StatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774359e2",
  null
  
)

export default component.exports